import { IRowNode } from "ag-grid-enterprise";
import { ITagModel } from "../../../common/models/ITagModel";

export function tagValueComparator(valueA: any, valueB: any, nodeA: IRowNode, nodeB: IRowNode) {

    const tagA: ITagModel | undefined = nodeA?.data && nodeA.data.hasOwnProperty('tag') ? nodeA.data['tag'] as ITagModel : undefined;
    const tagB: ITagModel | undefined = nodeB?.data && nodeB.data.hasOwnProperty('tag') ? nodeB.data['tag'] as ITagModel : undefined;

    const tagValueA = tagA?.tagValue;
    const tagValueB = tagB?.tagValue;

    return (tagValueA?.value ?? -Infinity) - (tagValueB?.value ?? -Infinity);
}
